import localStorageCartService from './localStorageCartService.js';
import LtoCart                 from './ltoCart.js';

let ShopCartToCartAdaptor = function (newCart) {
    let options = {};
    options.all = true;

    // Clear out the old cart;
    localStorageCartService.resetCartCookies();
    let oldCart = new LtoCart();

    let newCartItems = newCart.getItems(options);
    let sku;
    let qty;
    let maxQty;

    for (let i = 0; i < newCartItems.length; i++) {
        sku = newCartItems[i].sku;
        qty = newCartItems[i].getQty();
        maxQty = newCartItems[i].getMaxQty();
        oldCart.addItem(sku, qty, maxQty);
    }

    localStorageCartService.setCart(oldCart);

    return oldCart;
};

export default ShopCartToCartAdaptor;